if (!customElements.get("variant-selects")) {
  class e extends HTMLElement {
    constructor() {
      if (
        (super(),
        (this.sticky = this.dataset.sticky),
        (this.featured = this.dataset.featured),
        (this.isDisabledFeature = this.dataset.isDisabled),
        this.addEventListener("change", this.onVariantChange),
        (this.other = Array.from(
          document.querySelectorAll("variant-selects")
        ).filter((e) => e != this)),
        document.querySelector(".media-gallery") &&
          document
            .querySelector(".media-gallery")
            .classList.contains("has_slider"))
      ) {
        document.querySelector(".product-side-images");
        let i = Array.from(document.querySelectorAll(".product-sub-images"));
        if (document.querySelector(".eam-vertical-slider-active"))
          var e = document.querySelector(
            ".eam-vertical-slider-active"
          ).offsetTop;
        document.querySelector(".product-side-images").scrollTop = e - 200;
        let r,
          s,
          a = document.querySelector('.product-form [name="id"]').value,
          o = this.getVariantData().filter(function (e) {
            if (e.id == a) return e;
          });
        (o = o[0]),
          o.featured_media &&
            ((r = o.featured_media.alt),
            (s = this.getCurrentMediaGroup(o)),
            s &&
              document
                .querySelectorAll(".product-sub-images")
                .forEach(function (e) {
                  e.dataset.grpvl != s &&
                    "eam_all" != e.dataset.grpvl &&
                    (e.style.display = "none");
                })),
          new Flickity("#Product-Slider").destroy(),
          document
            .querySelectorAll(".product-images__slide")
            .forEach(function (e) {
              e.remove();
            });
        let n = 0;
        all_slides.forEach(function (e) {
          (e.dataset.grpvl != s && "eam_all" != e.dataset.grpvl) ||
            (n++,
            (document.querySelector("#Product-Slider").innerHTML =
              document.querySelector("#Product-Slider").innerHTML +
              e.outerHTML));
        }),
          0 == n &&
            all_slides.forEach(function (e) {
              document.querySelector("#Product-Slider").innerHTML =
                document.querySelector("#Product-Slider").innerHTML +
                e.outerHTML;
            }),
          document
            .querySelectorAll(".product-images__slide")
            .forEach(function (e) {
              (e.style.display = "block"), e.classList.remove("is-hidden");
            });
        var t = new Flickity("#Product-Slider", {
          wrapAround: !1,
          cellAlign: "left",
          pageDots: !0,
          contain: !0,
          selectedAttraction: 0.3,
          friction: 0.9,
          prevNextButtons: !0,
          on: {
            settle: function (e) {
              if (window.outerWidth > 768) {
                let e = document.querySelector(
                  ".product-images__slide.carousel__slide.is-selected"
                ).dataset.mediaId2;
                document
                  .querySelector(
                    '.product-sub-images[data-media-id="' + e + '"]'
                  )
                  .click();
              } else {
                let e = document.querySelector(
                  ".product-images__slide.carousel__slide.is-selected"
                ).dataset.mediaId2;
                document
                  .querySelector(
                    '.product-sub-images[data-media-id="' + e + '"]'
                  )
                  .click();
              }
            },
          },
        });
        if (this.currentVariant && null != s) {
          let e = 0;
          document
            .querySelectorAll(".product-sub-images")
            .forEach(function (t) {
              t.dataset.grpvl != s && "eam_all" != t.dataset.grpvl
                ? (t.style.display = "none")
                : (e++, (t.style.display = "block"));
            }),
            0 == e &&
              document
                .querySelectorAll(".product-sub-images")
                .forEach(function (e) {
                  e.style.display = "block";
                });
        }
        let l = o.featured_media.id,
          d = this.getVisibleProductThumbnail(l);
        d && d.click(),
          document
            .querySelectorAll(".product-sub-images")
            .forEach(function (e) {
              e.addEventListener("click", function (r) {
                document.querySelector(".eam-vertical-slider-active") &&
                  document
                    .querySelector(".eam-vertical-slider-active")
                    .classList.remove("eam-vertical-slider-active"),
                  e.classList.add("eam-vertical-slider-active");
                var s = document.querySelector(
                  ".eam-vertical-slider-active"
                ).offsetTop;
                document.querySelector(".product-side-images").scrollTop =
                  s - 200;
                i.indexOf(e);
                var a = document.querySelector(
                  ".eam-vertical-slider-active"
                ).offsetLeft;
                document.querySelector(".product-side-images").scrollLeft =
                  a - 200;
                i.indexOf(e);
                let o = Array.from(
                  document.querySelectorAll(".product-images__slide")
                ).indexOf(
                  document.querySelector(
                    '.product-images__slide[data-media-id2="' +
                      e.dataset.mediaId +
                      '"]'
                  )
                );
                window.outerWidth, t.select(o, !0, !0);
              });
            });
      } else {
        document
          .querySelectorAll(".product-images__slide")
          .forEach(function (e) {
            (e.style.display = "block"), e.classList.remove("is-hidden");
          });
        let e = {
          wrapAround: !1,
          cellAlign: "left",
          pageDots: !0,
          contain: !0,
          selectedAttraction: 0.3,
          friction: 0.9,
          asNavFor: document.querySelector(".product-images__slide"),
          prevNextButtons: !0,
          on: {
            settle: function (e) {
              if (window.outerWidth > 768) {
                let e = document.querySelector(
                  ".product-images__slide.carousel__slide.is-selected"
                ).dataset.mediaId2;
                document
                  .querySelector(
                    '.product-sub-images[data-media-id="' + e + '"]'
                  )
                  .click();
              } else {
                let e = document.querySelector(
                  ".product-images__slide.carousel__slide.is-selected"
                ).dataset.mediaId2;
                document
                  .querySelector(
                    '.product-sub-images[data-media-id="' + e + '"]'
                  )
                  .click();
              }
            },
          },
        };
        t = new Flickity("#Product-Slider", e);

        if (current_variant.featured_media) {
          let e = current_variant.featured_media.id;
          document
            .querySelector('.product-sub-images[data-media-id="' + e + '"]')
            .click(),
            document
              .querySelectorAll(".product-sub-images")
              .forEach(function (e) {
                e.addEventListener("click", function (i) {
                  i.preventDefault(),
                    document.querySelector(".eam-vertical-slider-active") &&
                      document
                        .querySelector(".eam-vertical-slider-active")
                        .classList.remove("eam-vertical-slider-active"),
                    e.classList.add("eam-vertical-slider-active");
                  var r = document.querySelector(
                    ".eam-vertical-slider-active"
                  ).offsetTop;
                  document.querySelector(".product-side-images").scrollTop =
                    r - 200;
                  vertical_slideshow_slides.indexOf(e);
                  var s = document.querySelector(
                    ".eam-vertical-slider-active"
                  ).offsetLeft;
                  document.querySelector(".product-side-images").scrollLeft =
                    s - 200;
                  vertical_slideshow_slides.indexOf(e);
                  let a = Array.from(
                    document.querySelectorAll(".product-images__slide")
                  ).indexOf(
                    document.querySelector(
                      '.product-images__slide[data-media-id2="' +
                        e.dataset.mediaId +
                        '"]'
                    )
                  );
                  window.outerWidth, t.select(a, !0, !0);
                });
              });
        }
      }
      document.querySelector(".product-side-images") &&
        (document.querySelector(".product-side-images").style.maxHeight =
          document.querySelector(".product-image-container .flickity-viewport")
            .clientHeight + "px");
    }
    getCurrentMediaGroup(e) {
      const t = Array.from(this.querySelectorAll("fieldset")).find((e) => {
        const t = (e.dataset.name || "").toLowerCase();
        return (
          t.includes("color") ||
          t.includes("colour") ||
          t.includes("couleur")
        );
      });
      if (t) {
        const e = t.querySelector("input:checked"),
          i = t.querySelector("select");
        if (e && e.value) return e.value;
        if (i && i.value) return i.value;
      }
      return e && e.featured_media
        ? (e.featured_media.alt || "").split("_")[1] || ""
        : "";
    }
    getVisibleProductThumbnail(e) {
      const t = e
        ? document.querySelector('.product-sub-images[data-media-id="' + e + '"]')
        : null;
      return t && "none" !== t.style.display
        ? t
        : Array.from(document.querySelectorAll(".product-sub-images")).find(
            function (e) {
              return "none" !== e.style.display;
            }
          ) || t;
    }
    connectedCallback() {
      this.updateOptions(),
        this.updateMasterId(),
        this.setDisabled(),
        this.setDisabledClass();
    }
    updatetextplug() {
      var e = $(
        ".product-section-2 fieldset.product-form__input.product-form__input--dropdown .select select"
      ).val();
      $(".plug_value").text(e);
    }
    onVariantChange() {
      this.currentVariant
        ? $(".klaviyo-bis-trigger").hide()
        : $(".klaviyo-bis-trigger").show(),
        this.updateOptions(),
        this.updateMasterId(),
        this.toggleAddButton(!0, "", !1),
        //this.updatePickupAvailability(),
        this.removeErrorMessage(),
        this.updateVariantText(),
        this.setDisabled(),
        this.setDisabledClass(),
        this.updateOther(),
        this.updatetextplug(),
        this.currentVariant
          ? (this.updateMedia(),
            this.featured || this.updateURL(),
            this.updateVariantInput(),
            this.renderProductInfo())
          : (this.toggleAddButton(!0, "", !0), this.setUnavailable()),
        dispatchCustomEvent("product:variant-change", {
          variant: this.currentVariant,
          sectionId: this.dataset.section,
        });

      console.log('===change', customElements.get("coupon-container"));
      const couponContainer = document.querySelector('coupon-container');
      if (couponContainer && couponContainer.resetPriceDom) {
        couponContainer.resetPriceDom();
      }
    }
    setDisabledClass() {
      const e = document.querySelectorAll(".single-add-to-cart-button"),
        t = document.querySelectorAll("variant-selects");

        var variantId = this.currentVariant.id;
      
        $('.variant-data-hidden').each(function() {
          var elementVariantId = $(this).data('variant-id');
          if (elementVariantId === variantId) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });

      e.forEach((element) => {
        element.dataset.currentPrice = (this.currentVariant.price / 100).toFixed(2);
      });
      
      this.currentVariant.available
        ? (e.forEach((e) => {
            let current_price = formatMoney(this.currentVariant.price, window.theme.settings.money_with_currency_format);

            const drawer_content = this.closest('#Product-Drawer-Content');
            if(drawer_content){
            if(drawer_content.querySelector('.product-volume-discount')) {
                const parentEl = drawer_content.querySelector('.product-add-to-cart-container');
                const volumeDiscount = parentEl.querySelector('.product-volume-discount');
                const tiers = volumeDiscount.querySelectorAll('.product-volume-discount-tier');
                const qtyInput = parentEl.querySelector('quantity-selector input');
                const currentPrice = this.currentVariant.price;
                const quantity = qtyInput.value;
                const qtyPrice = currentPrice * quantity;
                let discount = 0;
                tiers.forEach(function(tier){
                  const min = parseInt(tier.getAttribute('data-min'));
                  if(quantity >= min){
                    discount = parseFloat(tier.getAttribute('data-discount'));
                  }
                });
                const newPrice = qtyPrice - (qtyPrice * discount / 100);
                if(this.currentVariant.available){
                  current_price = formatMoney(newPrice, window.theme.settings.money_with_currency_format);
                }
            }
            }
            e.querySelector(".single-add-to-cart-button--text").innerHTML =
              window.theme.variantStrings.addToCart  +
              " ·&nbsp;" + current_price;
          }),
          document
            .querySelector(".product-add-to-cart-container")
            .classList.remove("is-sold-out"),
          t.forEach((e) => {
            e.classList.remove("is-sold-out_variations");
          }))
        : (e.forEach((e) => {
            e.querySelector(".single-add-to-cart-button--text").textContent =
              window.theme.variantStrings.soldOut;
          }),
          document
            .querySelector(".product-add-to-cart-container")
            .classList.add("is-sold-out"),
          t.forEach((e) => {
            e.classList.add("is-sold-out_variations");
          }));
    }
    updateOptions() {
      (this.fieldsets = Array.from(this.querySelectorAll("fieldset"))),
        (this.options = []),
        this.fieldsets.forEach((e, t) => {
          e.querySelector("select")
            ? this.options.push(e.querySelector("select").value)
            : e.querySelectorAll("input").length &&
              this.options.push(e.querySelector("input:checked").value);
        });
    }
    updateVariantText() {
      Array.from(this.querySelectorAll("fieldset")).forEach((e, t) => {
        let i = e.querySelector(".form__label__value");
        i && (i.innerHTML = this.options[t]);
      });


    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find(
        (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
      );
    }
    updateOther() {
      if ("false" !== this.dataset.updateUrl && this.other.length) {
        let e = this.other[0].querySelectorAll("fieldset"),
          t = Array.from(e);
        this.options.forEach((e, i) => {
          t[i].querySelector("select")
            ? (t[i].querySelector("select").value = e)
            : t[i].querySelectorAll("input").length &&
              (t[i].querySelector(`input[value="${e}"]`).checked = !0);
        }),
          this.other[0].updateOptions(),
          this.other[0].updateMasterId(),
          this.other[0].updateVariantText(),
          this.other[0].setDisabled();
      }
    }
    updateMedia() {
      if (this.currentVariant && this.currentVariant.featured_media)
        if (
          document.querySelector(".media-gallery") &&
          document
            .querySelector(".media-gallery")
            .classList.contains("has_slider")
        ) {
          let i = this.currentVariant.featured_media.alt,
            r = this.getCurrentMediaGroup(this.currentVariant);
          if (
            (new Flickity("#Product-Slider").destroy(),
            document
              .querySelectorAll(".product-images__slide")
              .forEach(function (e) {
                e.remove();
              }),
            this.currentVariant)
          ) {
            let e = 0;
            all_slides.forEach(function (t) {
              (t.dataset.grpvl != r && "eam_all" != t.dataset.grpvl) ||
                (e++,
                (document.querySelector("#Product-Slider").innerHTML =
                  document.querySelector("#Product-Slider").innerHTML +
                  t.outerHTML));
            }),
              0 == e &&
                all_slides.forEach(function (e) {
                  document.querySelector("#Product-Slider").innerHTML =
                    document.querySelector("#Product-Slider").innerHTML +
                    e.outerHTML;
                });
          }
          document
            .querySelectorAll(".product-images__slide")
            .forEach(function (e) {
              (e.style.display = "block"), e.classList.remove("is-hidden");
            });
          var e = new Flickity("#Product-Slider", {
            wrapAround: !1,
            cellAlign: "left",
            pageDots: !0,
            contain: !0,
            selectedAttraction: 0.3,
            friction: 0.9,
            prevNextButtons: !0,
            on: {
              settle: function (e) {
                if (window.outerWidth > 768) {
                  let e = document.querySelector(
                    ".product-images__slide.carousel__slide.is-selected"
                  ).dataset.mediaId2;
                  document
                    .querySelector(
                      '.product-sub-images[data-media-id="' + e + '"]'
                    )
                    .click();
                } else {
                  let e = document.querySelector(
                    ".product-images__slide.carousel__slide.is-selected"
                  ).dataset.mediaId2;
                  document
                    .querySelector(
                      '.product-sub-images[data-media-id="' + e + '"]'
                    )
                    .click();
                }
              },
            },
          });
          if (r) {
            let i = 0;
            null != r &&
              (document
                .querySelectorAll(".product-sub-images")
                .forEach(function (e) {
                  e.dataset.grpvl != r && "eam_all" != e.dataset.grpvl
                    ? (e.style.display = "none")
                    : (i++, (e.style.display = "block"));
                }),
              0 == i &&
                document
                  .querySelectorAll(".product-sub-images")
                  .forEach(function (e) {
                    e.style.display = "block";
                  }));
            let s = this.currentVariant.featured_media.id,
              a = this.getVisibleProductThumbnail(s);
            a && a.click();
            var t = Array.from(
              document.querySelectorAll(".product-sub-images")
            );
            document
              .querySelectorAll(".product-sub-images")
              .forEach(function (i) {
                i.addEventListener("click", function (r) {
                  document.querySelector(".eam-vertical-slider-active") &&
                    document
                      .querySelector(".eam-vertical-slider-active")
                      .classList.remove("eam-vertical-slider-active"),
                    i.classList.add("eam-vertical-slider-active");
                  var s = document.querySelector(
                    ".eam-vertical-slider-active"
                  ).offsetTop;
                  document.querySelector(".product-side-images").scrollTop =
                    s - 200;
                  t.indexOf(i);
                  var a = document.querySelector(
                    ".eam-vertical-slider-active"
                  ).offsetLeft;
                  document.querySelector(".product-side-images").scrollLeft =
                    a - 200;
                  t.indexOf(i);
                  let o = Array.from(
                    document.querySelectorAll(".product-images__slide")
                  ).indexOf(
                    document.querySelector(
                      '.product-images__slide[data-media-id2="' +
                        i.dataset.mediaId +
                        '"]'
                    )
                  );
                  window.outerWidth, e.select(o, !0, !0);
                });
              });
          }
        } else {
          const e = document.getElementById(
            `MediaGallery-${this.dataset.section}`
          );
          if (!e) return;
          let t = `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            i = e.querySelector(`[data-media-id="${t}"]`);
          if (
            document.querySelector(".media-gallery") &&
            document
              .querySelector(".media-gallery")
              .classList.contains("has_slider")
          )
            document
              .querySelector(
                '.product-sub-images[data-media-id="' +
                  this.currentVariant.featured_media.id +
                  '"]'
              )
              .click();
          else {
            if (
              (e.querySelectorAll("[data-media-id]").forEach((e) => {
                e.classList.remove("is-active");
              }),
              i.classList.add("is-active"),
              this.featured)
            )
              return;
            i.parentElement.prepend(i),
              window.setTimeout(() => {
                i.parentElement.scrollTo({
                  left: 0,
                  top: 0,
                  behavior: "smooth",
                });
              });
          }
        }
    }
    updateURL() {
      if(this.dataset.bulkOrder == 'true') {
        return;
      }
      this.currentVariant &&
        "false" !== this.dataset.updateUrl &&
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }
    updateShareUrl() {
      const e = document.getElementById(`Share-${this.dataset.section}`);
      e &&
        e.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }
    updateVariantInput() {
      document
        .querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment`
        )
        .forEach((e) => {
          const t = e.querySelector('input[name="id"]');
          (t.value = this.currentVariant.id),
            t.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
    updatePickupAvailability() {
      const e = document.querySelector(".pickup-availability-wrapper");
      e &&
        (this.currentVariant && this.currentVariant.available
          ? e.fetchAvailability(this.currentVariant.id)
          : (e.removeAttribute("available"), (e.innerHTML = "")));
    }
    removeErrorMessage() {
      const e = this.closest("section");
      if (!e) return;
      const t = e.querySelector("product-form");
      t && t.handleErrorMessage();
    }
    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
      ];
    }
    renderProductInfo() {
      let e = this.getSectionsToRender();
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((e) => e.text())
        .then((t) => {
          const i = new DOMParser().parseFromString(t, "text/html");
          if(!this.closest('#Product-Drawer')) {
            e.forEach((e) => {
              const t = document.getElementById(e),
                r = i.getElementById(e);
              r && t && (t.innerHTML = r.innerHTML);
              const s = document.getElementById(e),
                a = document.getElementById(e + "--sticky");
              s && s.classList.remove("visibility-hidden"),
                a && a.classList.remove("visibility-hidden");
            });
          }
            this.toggleAddButton(
              !this.currentVariant.available,
              window.theme.variantStrings.soldOut
            );
        });
    }
    toggleAddButton(e = !0, t = !1, i = !0) {
      if (!document.getElementById(`product-form-${this.dataset.section}`))
        return;
      const r = document.querySelectorAll(".single-add-to-cart-button");
      r &&
        r.forEach((t) => {
          t.querySelector(".single-add-to-cart-button--text") &&
            (e
              ? t.setAttribute("disabled", "disabled")
              : (t.removeAttribute("disabled"),
                t.classList.remove("loading"),
                this.currentVariant));
        });
      const couponContainer = document.querySelector('coupon-container');
      if (couponContainer && couponContainer.resetPriceDom) {
        couponContainer.resetPriceDom();
      }
    }
    setUnavailable() {
      const e = document.querySelectorAll(".single-add-to-cart-button"),
        t = document.getElementById(`price-${this.dataset.section}`),
        i = document.getElementById(`price-${this.dataset.section}--sticky`);
      e.forEach((e) => {
        const t = e.querySelector(".single-add-to-cart-button--text");
        e &&
          ((t.textContent = window.theme.variantStrings.unavailable),
          e.classList.add("sold-out"));
      }),
        t && t.classList.add("visibility-hidden"),
        i && i.classList.add("visibility-hidden");
    }
    setDisabled() {
      if ("true" != this.isDisabledFeature) return;
      /*
      let intervalQuick = setInterval(function(){
        $('#Product-Drawer-Content .single-add-to-cart-button').removeAttr('disabled');
      }, 100); 
      setTimeout(function() {
        clearInterval(intervalQuick);
      }, 2500);
      */
      const e = this.getVariantData();
      if (e) {
        const t = this.currentVariant.options.map((e, t) => ({
            value: e,
            index: `option${t + 1}`,
          })),
          i = this.createAvailableOptionsTree(e, t);
        this.fieldsets.forEach((e, t) => {
          const r = Object.values(i)[t];
          r &&
            (e.querySelector("select")
              ? r.forEach((t, i) => {
                  t.isUnavailable ||
                    (e.querySelector(
                      "option[value=" + JSON.stringify(t.value) + "]"
                    ).disabled = !1);
                })
              : e.querySelectorAll("input").length &&
                e.querySelectorAll("input").forEach((e, t) => {
                  e.classList.toggle("is-disabled", r[t].isUnavailable);
                }));
        });
      }
      return !0;
    }
    createAvailableOptionsTree(e, t) {
      return e.reduce(
        (e, i) => (
          Object.keys(e).forEach((r) => {
            if (null === i[r]) return;
            let s = e[r].find((e) => e.value === i[r]);
            void 0 === s &&
              ((s = { value: i[r], isUnavailable: !0 }), e[r].push(s));
            const a = t.reduce(
              (e, { value: t, index: r }) => (i[r] === t ? e + 1 : e),
              0
            );
            a >= t.length - 1 &&
              (s.isUnavailable =
                (!s.isUnavailable || !i.available) && s.isUnavailable),
              (this.currentVariant && this.currentVariant.available) ||
                !t.find((e) => e.value === s.value && r === e.index) ||
                (s.isUnavailable = !0),
              "option1" === r &&
                (s.isUnavailable =
                  (!s.isUnavailable || !i.available) && s.isUnavailable);
          }),
          e
        ),
        { option1: [], option2: [], option3: [] }
      );
    }
    getVariantData() {
      return (
        (this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          )),
        this.variantData
      );
    }
  }
  customElements.define("variant-selects", e);
  class t extends e {
    constructor() {
      super();
    }
    updateOptions() {
      const e = Array.from(this.querySelectorAll("fieldset"));
      this.options = e.map(
        (e) =>
          Array.from(e.querySelectorAll("input")).find((e) => e.checked).value
      );
    }
  }
  customElements.define("variant-radios", t);
}
if (!customElements.get("product-slider")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.closest(".thb-product-detail");
      if (
        ((this.pagination = this.parentElement.querySelector(
          ".product-images-buttons"
        )),
        (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
        this.addEventListener("change", this.setupProductGallery),
        this.setupProductGallery(),
        this.pagination)
      ) {
        this.setupPagination(),
          this.addEventListener("scroll", this.updatePagination.bind(this));
        new ResizeObserver((e) => this.onPaginationResize()).observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) return;
      let e = Array.from(this.querySelectorAll(".product-single__media-image"));
      this.setEventListeners(this, e);
    }
    buildItems(e) {
      return e.map((e) => {
        let t = e.querySelector(".product-single__media-zoom");
        return {
          src: t.getAttribute("href"),
          msrc: t.dataset.msrc,
          w: t.dataset.w,
          h: t.dataset.h,
          title: t.getAttribute("title"),
        };
      });
    }
    setEventListeners(e, t) {
      let i = e.querySelectorAll(".product-single__media-zoom"),
        r = e.buildItems(t),
        s = e.dataset.captions,
        a = document.querySelectorAll(".pswp")[0],
        o = {
          maxSpreadZoom: 2,
          loop: !1,
          allowPanToNext: !1,
          closeOnScroll: !1,
          showHideOpacity: !1,
          arrowKeys: !0,
          history: !1,
          captionEl: s,
          fullscreenEl: !1,
          zoomEl: !1,
          shareEl: !1,
          counterEl: !0,
          arrowEl: !0,
          preloaderEl: !0,
        };
      i.forEach((e) => {
        e.addEventListener("click", (t) => {
          let i = e.dataset.index;
          if (
            ((o.index = parseInt(i, 10)),
            (o.getThumbBoundsFn = () => {
              const t = e.closest(".product-single__media"),
                i = window.pageYOffset || document.documentElement.scrollTop,
                r = t.getBoundingClientRect();
              return { x: r.left, y: r.top + i, w: r.width };
            }),
            "undefined" != typeof PhotoSwipe)
          ) {
            let e = new PhotoSwipe(a, PhotoSwipeUI_Default, r, o);
            e.listen("firstUpdate", function () {
              e.listen("parseVerticalMargin", function (e) {
                e.vGap = { top: 50, bottom: 50 };
              });
            }),
              e.init();
          }
          t.preventDefault();
        });
      });
    }
    setupPagination() {
      (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (e) => e.clientWidth > 0
      )),
        this.sliderItemsToShow.length < 2 ||
          ((this.sliderItemOffset =
            this.sliderItemsToShow[1].offsetLeft -
            this.sliderItemsToShow[0].offsetLeft),
          (this.currentPageElement = this.pagination.querySelector(
            ".slider-counter--current"
          )),
          (this.pageTotalElement = this.pagination.querySelector(
            ".slider-counter--total"
          )),
          (this.prevButton = this.pagination.querySelector(
            'button[name="previous"]'
          )),
          (this.nextButton = this.pagination.querySelector(
            'button[name="next"]'
          )),
          this.prevButton.addEventListener(
            "click",
            this.onPaginationButtonClick.bind(this)
          ),
          this.nextButton.addEventListener(
            "click",
            this.onPaginationButtonClick.bind(this)
          ),
          this.updatePagination());
    }
    onPaginationResize() {
      (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (e) => e.clientWidth > 0
      )),
        this.sliderItemsToShow.length < 2 ||
          (this.sliderItemOffset =
            this.sliderItemsToShow[1].offsetLeft -
            this.sliderItemsToShow[0].offsetLeft);
    }
    onPaginationButtonClick(e) {
      e.preventDefault(),
        (this.slideScrollPosition =
          "next" === e.currentTarget.name
            ? this.scrollLeft + 1 * this.sliderItemOffset
            : this.scrollLeft - 1 * this.sliderItemOffset),
        this.scrollTo({ left: this.slideScrollPosition });
    }
    updatePagination() {
      if (!this.nextButton) return;
      const e = this.currentPage;
      (this.currentPage =
        Math.round(this.scrollLeft / this.sliderItemOffset) + 1),
        this.currentPageElement &&
          (this.currentPageElement.textContent = this.currentPage),
        this.currentPage != e &&
          this.dispatchEvent(
            new CustomEvent("slideChanged", {
              detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1],
              },
            })
          ),
        this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.scrollLeft
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        )
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled");
    }
    isSlideVisible(e, t = 0) {
      const i = this.clientWidth + this.scrollLeft - t;
      return (
        e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.scrollLeft
      );
    }
  }
  customElements.define("product-slider", e);
}
if (
  (customElements.get("product-form") ||
    customElements.define(
      "product-form",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.sticky = this.dataset.sticky),
            (this.form = document.getElementById(
              `product-form-${this.dataset.section}`
            )),
            (this.form.querySelector("[name=id]").disabled = !1),
            this.sticky ||
              this.form.addEventListener(
                "submit",
                this.onSubmitHandler.bind(this)
              ),
            (this.cartNotification =
              document.querySelector("cart-notification")),
            (this.body = document.body),
            (this.hideErrors = "true" === this.dataset.hideErrors);
        }
        redirectlocation() {
          /*window.location.href="https://www.laifentech.com/cart"*/
        }
        onSubmitHandler(e) {
          if ((e.preventDefault(), !this.form.reportValidity())) return;
          const t = document.querySelectorAll(".single-add-to-cart-button");
          t.forEach((e) => {
            e.classList.contains("loading") ||
              (e.setAttribute("aria-disabled", !0), e.classList.add("loading"));
          }),
            this.handleErrorMessage();
          const i = {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/javascript",
            },
          };
          let r = new FormData(this.form);
          r.append(
            "sections",
            this.getSectionsToRender().map((e) => e.section)
          ),
            r.append("sections_url", window.location.pathname),
            (i.body = r),
            fetch(`${theme.routes.cart_add_url}`, i)
              .then((e) => e.json())
              .then((e) => {
                if (e.status)
                  return (
                    dispatchCustomEvent("product:variant-error", {
                      source: "product-form",
                      productVariantId: r.get("id"),
                      errors: e.description,
                      message: e.message,
                    }),
                    void this.handleErrorMessage(e.description)
                  );
                this.renderContents(e),
                  dispatchCustomEvent("cart:item-added", {
                    product: e.hasOwnProperty("items") ? e.items[0] : e,
                  });
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                t.forEach((e) => {
                  e.classList.remove("loading"),
                    e.removeAttribute("aria-disabled");
                });
              });
        }
        getSectionsToRender() {
          return [
            { id: "Cart", section: "main-cart", selector: ".thb-cart-form" },
            {
              id: "Cart-Drawer",
              section: "cart-drawer",
              selector: ".cart-drawer",
            },
            {
              id: "cart-drawer-toggle",
              section: "cart-bubble",
              selector: ".thb-item-count",
            },
          ];
        }
        renderContents(e) {
          this.getSectionsToRender().forEach((t) => {
            if (!document.getElementById(t.id)) return;
            ((
              document.getElementById(t.id).querySelector(t.selector) ||
              document.getElementById(t.id)
            ).innerHTML = this.getSectionInnerHTML(
              e.sections[t.section],
              t.selector
            )),
              "undefined" != typeof CartDrawer && new CartDrawer(),
              "undefined" != typeof Cart && new Cart().renderContents(e);
          });
          let t = document.getElementById("Product-Drawer");
          t && t.contains(this)
            ? (t
                .querySelector(".product-quick-images--container")
                .classList.remove("active"),
              document.body.classList.remove("open-quick-view"),
              window.innerWidth < 1069
                ? (t.classList.remove("active"),
                  document.getElementById("Cart-Drawer") &&
                    (document
                      .getElementById("Cart-Drawer")
                      .classList.add("active"),
                    document.body.classList.add("open-cart"),
                    document
                      .getElementById("Cart-Drawer")
                      .querySelector(".product-recommendations--full")
                      .classList.add("active"),
                    dispatchCustomEvent("cart-drawer:open")))
                : t
                    .querySelector(".product-quick-images--container")
                    .addEventListener("transitionend", function () {
                      t.classList.remove("active"),
                        document.getElementById("Cart-Drawer") &&
                          (document
                            .getElementById("Cart-Drawer")
                            .classList.add("active"),
                          document.body.classList.add("open-cart"),
                          document
                            .getElementById("Cart-Drawer")
                            .querySelector(".product-recommendations--full")
                            .classList.add("active"),
                          dispatchCustomEvent("cart-drawer:open"));
                    }),
              document.getElementById("Cart-Drawer") ||
                document.body.classList.remove("open-cc"))
            : document.getElementById("Cart-Drawer") &&
              (document.body.classList.add("open-cc"),
              document.body.classList.add("open-cart"),
              document.getElementById("Cart-Drawer").classList.add("active"),
              dispatchCustomEvent("cart-drawer:open"));
        }
        getSectionInnerHTML(e, t = ".shopify-section") {
          return new DOMParser()
            .parseFromString(e, "text/html")
            .querySelector(t).innerHTML;
        }
        handleErrorMessage(e = !1) {
          this.hideErrors ||
            ((this.errorMessageWrapper =
              this.errorMessageWrapper ||
              this.querySelector(".product-form__error-message-wrapper")),
            (this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
            this.errorMessageWrapper.toggleAttribute("hidden", !e),
            e && (this.errorMessage.textContent = e));
        }
      }
    ),
  !customElements.get("product-add-to-cart-sticky"))
) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.animations_enabled =
          document.body.classList.contains("animations-true") &&
          "undefined" != typeof gsap);
    }
    connectedCallback() {
      this.setupObservers(), this.setupToggle();
    }
    setupToggle() {
      const e = this.querySelector(".product-add-to-cart-sticky--inner"),
        t = this.querySelector(".product-add-to-cart-sticky--content");
      if (this.animations_enabled) {
        const i = gsap.timeline({
          reversed: !0,
          paused: !0,
          onStart: () => {
            e.classList.add("sticky-open");
          },
          onReverseComplete: () => {
            e.classList.remove("sticky-open");
          },
        });
        i
          .set(t, { display: "block", height: "auto" }, "start")
          .from(t, { height: 0, duration: 0.25 }, "start+=0.001"),
          e.addEventListener("click", function () {
            return i.reversed() ? i.play() : i.reverse(), !1;
          });
      } else
        e.addEventListener("click", function () {
          return t.classList.toggle("active"), !1;
        });
    }
    setupObservers() {
      let e = this,
        t = new IntersectionObserver(
          function (t) {
            t.forEach((t) => {
              if (
                (t.target === r &&
                  (t.intersectionRatio > 0
                    ? e.classList.remove("sticky--visible")
                    : 0 == t.intersectionRatio &&
                      e.formPassed &&
                      e.classList.add("sticky--visible")),
                t.target === i)
              ) {
                let r = i.getBoundingClientRect();
                0 === t.intersectionRatio && window.scrollY > r.top + r.height
                  ? ((e.formPassed = !0), e.classList.add("sticky--visible"))
                  : 1 === t.intersectionRatio &&
                    ((e.formPassed = !1),
                    e.classList.remove("sticky--visible"));
              }
            });
          },
          { threshold: [0, 1] }
        ),
        i = document.getElementById(`product-form-${this.dataset.section}`),
        r = document.getElementById("footer");
      (e.formPassed = !1), t.observe(i), t.observe(r);
    }
  }
  customElements.define("product-add-to-cart-sticky", e);
}
if (!customElements.get("side-panel-links")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.links = this.querySelectorAll("button")),
        (this.drawer = document.getElementById("Product-Information-Drawer")),
        (this.buttons = this.drawer.querySelector(".side-panel-content--tabs")),
        (this.panels = this.drawer
          .querySelector(".side-panel-content--inner")
          .querySelectorAll(".side-panel-content--tab-panel")),
        (this.body = document.body);
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {}
    setupObservers() {
      this.links.forEach((e, t) => {
        e.addEventListener("click", (e) => {
          this.body.classList.add("open-cc"),
            this.buttons.toggleActiveClass(t),
            this.drawer.classList.add("active");
        });
      });
    }
  }
  customElements.define("side-panel-links", e);
}

if (!customElements.get("coupon-container")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // console.log('===coupon-container', "connectedCallback");
      // console.log(this.getCouponData(),'===');
      this.getCouponData();
      this.initCode();
    }
    getCouponData () {
      return (
        (this.couponData = this.couponData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.couponData
      );
    }
    initCode() {
      // console.log('===coupon-container', "init");
      const { coupon_price, sale_type, coupon_code } = this.couponData;
      // console.log(coupon_price, sale_type, coupon_code,'====');
      
      if (coupon_price && sale_type && coupon_code) {
        if (coupon_code) {
          fetch(`/discount/${coupon_code}`).then(async () => {
            console.log('===copy-code==success');
            this.resetPriceDom();
          }).catch(e => {
            console.log('===copy-code==error', e);
          });
        }
      }
    }
    resetPriceDom() {
      const { coupon_code, coupon_price, sale_type } = this.couponData;
      const price_container = document.querySelector('.product-price-container .price-backup');
      const money = Number(price_container.getAttribute('money')); // 分
      let save_price = 0;
      function floorToTwo(num) {
        return Math.floor(num * 100) / 100;
      }
      if (coupon_price && coupon_code) {
        if (sale_type === 'save_amount') {
          save_price = Number(coupon_price).toFixed(2);
        } else if (sale_type === 'save_percentage') {
          save_price = floorToTwo(money * coupon_price / 100 / 100).toFixed(2);
        }
        if(save_price > 0) {
          const savePriceDom = price_container.querySelector('.save-price');
          if (savePriceDom) {
            savePriceDom.textContent = `${currency}${save_price}`;
          } else {
            const save_dom = `<span class="badges">
                 <span class="badge onsale" style="margin-right: 10px;">with code save<p class="save-price">${currency}${save_price}</p></span>
            </span>`
            price_container.innerHTML = price_container.innerHTML + save_dom;
          }
        }
      }
    }
  }
  customElements.define("coupon-container", e);
}
"undefined" != typeof addIdToRecentlyViewed && addIdToRecentlyViewed();

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-option-radio').forEach(function(radio) {
    radio.addEventListener('change', async function() {
      // console.log('change color')
      const productBlock = this.closest('.product-information');
      const productTitle = productBlock.querySelector('.product-title').textContent;
      const priceElement = productBlock.querySelector('.price-backup');
      // console.log(productBlock,'productBlock')
      // console.log(priceElement.textContent,'priceElement')
      // console.log(productTitle, 'productTitle')
      const price = priceElement?.textContent.trim();
      const currency = priceElement.textContent.trim().charAt(0);
      const savePriceElement = document.querySelector('.save-price');
      
      const discount = savePriceElement ? parseFloat(savePriceElement.textContent.replace(/[^0-9,]/g, '').replace(',', '.')) : 0;

      window.dataLayer.push({ 'event_parameters': null });
      window.dataLayer.push({
        'event': 'ga4Event',
        'event_name': 'view_item',
        'event_parameters': {
          'currency': currency,
          'value': Number(price),
          'items': [{
            'item_id': this.dataset.productSku,
            'item_name': productTitle,
            'discount': discount,
            'index': 1,
            'item_category': this.dataset.productId,
            'item_category2': this.value,
            'item_variant': this.dataset.productType,
            'price': price,
            'quantity': 1,
            'currency': currency
          }]
        }
      });
    });
  });
});
